import apiEndPoints from '../../utils/apiEndPoints'
import { apiCall } from '../../utils/httpClient';

const addUserAnnouncement = async (params) => {
    const data = await apiCall("post", apiEndPoints.USERANNOUNCEMENT, params);
    return data;
};

const announcementService = {
    addUserAnnouncement,
};

export default announcementService;